<template>
    <div class="rating-enter">
        <span class="rating-enter__stars">
            <span v-for="i in maxGrade" :key="i" :class="starClass(maxGrade + 1 - i)" @click="gradeSelected(maxGrade + 1 - i)">
                <svg><use xlink:href="#icon-star" /></svg>
            </span>
        </span>

        <div v-if="showTextGrade" class="rating-enter__grade-number">
            {{ grade ? grade.toFixed(1) : '&nbsp;' }}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            maxGrade: { type: Number, default: 5 },
            showTextGrade: { type: Boolean, default: true },
        },
        data() {
            return {
                grade: null,
            }
        },
        methods: {
            starClass(star) {
                return {
                    'rating-enter__star': true,
                    'rating-enter__star--on': star <= this.grade,
                }
            },
            gradeSelected(star) {
                this.grade = star
                this.$emit('rated', this.grade)
            },
        },
    }
</script>
